export const SERVICE_COLOR = '#FF6E2E';
export const SERVICE_LIGHT = '#ff6410';
export const SERVICE_DARK = '#ff3c10';

export const SERVICE_COLOR_2 = '#FED278';
export const SERVICE_COLOR_3 = '#FDF9EA';

export const ACTIVE_SERVICE_COLOR_2 = '#fecb78';

export const DARK_GRAY = 'rgb(43, 58, 78)';
export const LIGHT_GRAY = '#E0E0E0';

export const TEXT_PRIMARY = '#484848';
export const TEXT_SECONDARY = '#909090';

export const BORDER_COLOR = '#BEBEBE';
export const BORDER_COLOR_2 = '#FED278';

export const HIRAGINO_FONT =
  '-apple-system, "ヒラギノ角ゴ ProN", "Hiragino Kaku Gothic ProN", "Hiragino Sans", "Meiryo", "メイリオ", "Helvetica", "MS PGothic", arial, sans-serif';

export const LINE_BASE = '#00C300';
export const LINE_HOVER = '#00E000';
export const LINE_PRESS = '#00B300';

export const FB_BASE = '#4267B2';

export const TWITTER_BASE = '#38A1F3';

export const FACEBOOK_BASE = '#1877F2';

export const ONE_ODAKYU_BASE = '#0082cd';

export const MAIL_BASE = '#db4437';

export const DARK_RED = '#dc0000';

export const AMBASSADOR_COLOR = '#ff5910';
